import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import albumsData from '../data/Albums.json';
import PageTemplate from '../components/Common/PageTemplate';
import './Gallery.css'; // CSS for styling

const AlbumDetailPage = () => {
  const { albumId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const album = albumsData.find(a => a.link === albumId);
  const albumImages = album?.images || [];

  if (!album) {
    return (
      <PageTemplate title="Albüm Bulunamadı">
        <div className="album-detail-container">
          <p>Aradığınız albüm bulunamadı veya silinmiş olabilir.</p>
        </div>
      </PageTemplate>
    );
  }

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % albumImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + albumImages.length) % albumImages.length);
  };

  return (
    <PageTemplate title={`Foto Galeri: ${album.title}`}>
      <div className="album-detail-page">
        <div className="breadcrumb">
          <Link to="/albums">Tüm Albümler</Link> <span>/</span> {album.title}
        </div>
        
        {albumImages.length > 0 ? (
          <div className="image-grid">
            {albumImages.map((image, index) => (
              <div key={index} className="image-card" onClick={() => openModal(index)}>
                <img src={image.src} alt={image.alt || album.title} loading="lazy" />
              </div>
          ))}
        </div>
        ) : (
          <p>Bu albüm için hiç fotoğraf eklenmemiştir.</p>
      )}

      {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>&times;</span>
            <button className="prev-button" onClick={prevImage}>&#10094;</button>
              <img 
                src={albumImages[currentImageIndex].src} 
                alt={albumImages[currentImageIndex].alt || album.title} 
              />
            <button className="next-button" onClick={nextImage}>&#10095;</button>
          </div>
        </div>
      )}
        </div>
    </PageTemplate>
  );
};

export default AlbumDetailPage;